import { render, staticRenderFns } from "./recharge_delivery.vue?vue&type=template&id=2c869ce3&"
import script from "./recharge_delivery.vue?vue&type=script&lang=ts&"
export * from "./recharge_delivery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports